import { Product } from '../../@types/wishlist.js';
import { AbstractApi } from './abstract-api.js';

export interface CartFavoritesApiResponse {
  items: Product[];
}

export class CartFavoritesApiInstance extends AbstractApi {
  async getItems(endpoint: string): Promise<CartFavoritesApiResponse> {
    return this.get<CartFavoritesApiResponse>(endpoint, 'Cart favorites');
  }
}

export const cartFavoritesApi = new CartFavoritesApiInstance();
